module.exports = __webpack_public_path__ + "img/creditCard_b.4741bb43.svg";